import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = req.headers;
    let data: any = localStorage.getItem(environment.dataKey);
    if (data) {
      data = JSON.parse(atob(data));
      if (data.token) { headers = headers.set('Authorization', 'Bearer ' + data.token); }
    }
    const clonedRequest = req.clone({ headers });
    return next.handle(clonedRequest).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // To do
      }
    }, (error: any) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401 || error.status === 403) { localStorage.clear(); }
      }
    }));
  }

}